// const BASE_URL = import.meta.env.REACT_HOST_URL;
const BASE_URL = 'https://erp.globalmanikchand.in/api/method';
const SERVER_URL = 'https://erp.globalmanikchand.in';

// const BASE_URL = 'https://demo.silverbluewater.com/api/method';
// const SERVER_URL = 'https://demo.silverbluewater.com';

// const CLIENT_URL = 'https://globalmanikchand.in/';
const CLIENT_URL = 'http://localhost:3000/';

// const BASE_URL = 'https://192.168.1.25:8009/api/method'
// const SERVER_URL = 'https://192.168.1.25:8009';
let BASE_NAME = 'PROD';
if (BASE_URL.includes('localhost')) {
  BASE_NAME = 'LOCAL';
} else if (BASE_URL.includes('ngrok')) {
  BASE_NAME = 'NGROK';
}

const config = {
  BASE_URL,
  BASE_NAME,
  SERVER_URL,
  CLIENT_URL,
};

export default config;
